<template>
  <b-modal
    ref="modal"
    v-model="open"
    :title="title"
    :size="modalSize"
    :modal-class="modalClass"
    :dialog-class="dialogClass"
    :hide-footer="!showDefaultFooter"
    @ok.prevent="onOk"
    @cancel="onCancel"
    @close="onCancel"
  >
    <component
      :is="component"
      ref="form"
      v-model="form"
      :store-id="storeId"
      :toy="toy"
      :products-amount="productsAmount"
      :rent-amount="rentAmount"
      :prefilled-period="prefilledPeriod"
      :duplicate-mode="duplicateMode"
      :duplicate-source-rent-id="duplicateSourceRentId"
      :store-has-commissions="storeHasCommissions"
      :store-has-rent-signature="storeHasRentSignature"
      :store-periods="storePeriods"
      :loyalty-discount-enabled="loyaltyDiscountEnabled"
      @submit="onSubmit"
      @flow-step-change="onFlowStepChange"
      @loyalty-discount-change="$emit('loyalty-discount-change', $event)"
    />

    <template v-if="showDefaultFooter" #footer>
      <div class="text-right">
        <b-button variant="secondary" @click="onCancelClick">Cancelar</b-button>
        <b-button variant="primary" :disabled="disabled" @click="onOk">
          {{ okLabel }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import partials from './partials'
import { RENT_ACTIONS, RENT_ACTIONS_TITLES } from '@/constants'

export default {
  name: 'ToyRentModal',
  props: {
    value: {
      type: Boolean
    },
    toy: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    initialState: {
      type: Function,
      default: () => ({})
    },
    rentAmount: {
      type: Number,
      default: 0
    },
    productsAmount: {
      type: Number,
      default: 0
    },
    prefilledClient: {
      type: Object,
      default: null
    },
    prefilledPeriod: {
      type: Object,
      default: null
    },
    storeId: {
      type: [String, Number],
      default: null
    },
    storeHasCommissions: {
      type: Boolean,
      default: null
    },
    storeHasRentSignature: {
      type: Boolean,
      default: null
    },
    duplicateMode: {
      type: Boolean,
      default: false
    },
    duplicateSourceRentId: {
      type: [String, Number],
      default: null
    },
    storePeriods: {
      type: Array,
      default: () => []
    },
    loyaltyDiscountEnabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let baseForm = this.initialState() || {}

    if (this.prefilledClient) {
      baseForm.id = this.prefilledClient.id || ''
      baseForm.document = this.prefilledClient.document || ''
      baseForm.name = this.prefilledClient.name || ''
      baseForm.phone = this.prefilledClient.phone || ''
      baseForm.email = this.prefilledClient.email || ''
      baseForm.updateCustomer = false
    }

    if (this.duplicateMode && this.duplicateSourceRentId) {
      baseForm.duplicateSourceRentId = this.duplicateSourceRentId
    }

    if (this.prefilledPeriod) {
      baseForm.periodId = this.prefilledPeriod.id || ''
      baseForm.periodName =
        `${this.prefilledPeriod.time} minutos - R$ ${Number(
          this.prefilledPeriod.price
        ).toFixed(2)}` || ''
    }

    if (typeof baseForm.commissionUserStoreId === 'undefined') {
      baseForm.commissionUserStoreId = null
    }

    return {
      form: baseForm,
      disabled: false,
      startFlowStep: 'form'
    }
  },
  computed: {
    open: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    },
    component() {
      return partials[this.action]
    },
    title() {
      return `${RENT_ACTIONS_TITLES[this.action]} Aluguel - ${this.toy.name}`
    },
    isStartRent() {
      return this.action === RENT_ACTIONS.START
    },
    showDefaultFooter() {
      if (!this.isStartRent) return true
      return this.startFlowStep === 'form'
    },
    okLabel() {
      if (this.isStartRent) return 'Ok para iniciar o aluguel'
      return 'Ok'
    },
    modalSize() {
      if (this.isStartRent && this.startFlowStep === 'sign') return 'xl'
      if (this.action === RENT_ACTIONS.CLOSE) return 'lg'
      return undefined
    },
    modalClass() {
      if (this.isStartRent && this.startFlowStep === 'sign')
        return 'rent-signature-fullscreen'
      return ''
    },
    dialogClass() {
      if (this.isStartRent && this.startFlowStep === 'sign')
        return 'rent-signature-dialog'
      return ''
    }
  },
  methods: {
    onOk() {
      this.$refs.form.handleSubmit()
    },
    onCancelClick() {
      this.$refs.modal.hide()
    },
    onFlowStepChange(step) {
      if (!this.isStartRent) return
      this.startFlowStep = step || 'form'
    },
    onCancel() {
      this.form = this.initialState()
      this.startFlowStep = 'form'
      this.$emit('cancel')
    },
    onSubmit(form) {
      const { toy } = this
      this.$emit('ok', { toy, form })
    }
  }
}
</script>

<style>
@media (max-width: 991.98px) {
  .rent-signature-fullscreen .modal-dialog {
    margin: 0;
    max-width: 100%;
    height: 100%;
  }
  .rent-signature-fullscreen .modal-content {
    height: 100vh;
    border-radius: 0;
  }
  .rent-signature-fullscreen .modal-body {
    overflow: auto;
  }
}
</style>
